import { api } from "@/api/client";
import { RecordSignature } from "./record";
import { UserSignature } from "@/api/user";

export type CertificateSummary = {
  recordId: string;
  recordNumber: string;
  recordStandardGroup: string;
  recordType: string;
  testDate: string;
  expiryDate: string;
  matProductForms: string;
  processes: string;
  canRevalidate: boolean;
};

export function getCertificateSummary(welderId: string) {
  return api.get<CertificateSummary[]>(`certificates?welderId=${welderId}`);
}

export function revalidate(signature: RecordSignature, userSignature?: UserSignature) {
  return api.post(`certificates/revalidate/${signature.recordId}`, {
    userSignatureId: userSignature?.userSignatureId,
  });
}
